import React from 'react';
import {RatingStars} from "../RatingStars";

export interface TestimonialCardProps {
  avatar?: any;
  name: string;
  rating: number;
  text: string;
}

// // Helper to get the best avatar url from different possible shapes
// const getAvatarUrl = (avatar: any): string => {
//   if (!avatar) return '/images/avatars/female.png';
//   if (typeof avatar === 'string') return avatar;
//   if (avatar.formats?.thumbnail?.url) return avatar.formats.thumbnail.url;
//   if (avatar.formats?.small?.url) return avatar.formats.small.url;
//   if (avatar.url) return avatar.url;
//   return '/images/avatars/female.png';
// };

const clampStars = (rating?: number) => Math.max(0, Math.min(5, rating || 0));

const TestimonialCard: React.FC<TestimonialCardProps> = ({avatar, name, rating, text}) => {
  // const version = useMemo(() => getFunnelVersion(), []);
  //
  // if (version === 1) {
  //   return (
  //     <div className="testimonial-card testimonial-card-row">
  //       <div className="testimonial-header-row">
  //         <img src={getAvatarUrl(avatar)} alt={name} className="testimonial-avatar" />
  //         <div className="testimonial-header-info">
  //           <span className="testimonial-name">{name}</span>
  //           <span className="testimonial-stars">{'★'.repeat(clampStars(rating))}</span>
  //         </div>
  //       </div>
  //       <div className="testimonial-quote">{text}</div>
  //     </div>
  //   );
  // }

  // Funnel version 2: clean card like on the mock (name, yellow stars, quote)
  return (
    <div className="testimonial-card"
         style={{background: '#fff', border: '1px solid #E5E7EB', borderRadius: 12, padding: 16}}>
      <div className="testimonial-name" style={{marginBottom: 4}}>{name}</div>
      <RatingStars rating={clampStars(rating)}/>
      <div className="testimonial-quote">{text}</div>
    </div>
  );

};

export default TestimonialCard;
